<template>
  <!-- Header per provided example -->
  <header id="header" data-menu-padding="35">
    <div id="header-wrap">
      <div class="container">
        <div class="header-row">
          <div id="logo">
            <router-link to="/" class="standard-logo" aria-label="GAP Home">
              <img :src="resolvedLogo" alt="GAP Logo" @error="onLogoError" :style="{ width: '200px', height: '100px' }" />
            </router-link>

          </div>

          <nav class="primary-menu sub-title">
            <ul class="menu-container">
              <li class="menu-item">
                <router-link class="menu-link" to="/">
                  <div>GAP Global</div>
                  <span>All Instructor led Classes </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link class="menu-link" to="/climate">
                  <div>Climate</div>
                  <span>Climate Faculty</span>
                </router-link>
              </li>
              <li class="menu-item">
                <a class="menu-link" href="https://gaplib.gapmanagementinstitute.org/#/library" target="_blank" rel="noopener">
                  <div>GAP Lib</div>
                  <span>GAP Library</span>
                </a>
              </li>
              <li class="menu-item">
                <a class="menu-link" href="https://elearning.gapmanagementinstitute.org/" target="_blank" rel="noopener">
                  <div>E-learning</div>
                  <span>GAP Online Courses</span>
                </a>
              </li>
              <li class="menu-item">
                <a class="menu-link" href="https://gapmanagement.institute/contact-us" target="_blank" rel="noopener">
                  <div>Contact Us</div>
                  <span>Get In Touch</span>
                </a>
              </li>
              <li class="menu-item">
                <router-link class="menu-link" to="/my-centre">
                  <div>My Centre</div>
                  <span>Access Your Site</span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link class="menu-link" to="/downloads">
                  <div>Downloads</div>
                  <span>More Information</span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavigationMenu',
  props: {
    logoSrc: {
      type: String,
      default: '/assets/img/gap_logo.png'
    }
  },
  data() {
    return {
      resolvedLogo: this.logoSrc
    }
  },
  methods: {
    onLogoError() {
      if (this.resolvedLogo !== '/assets/img/logo-placeholder.svg') {
        this.resolvedLogo = '/assets/img/logo-placeholder.svg'
      }
    }
  }
}
</script>

<style scoped>
</style>
